/**
 * @generated SignedSource<<a7c0da8c8b5122655600badb7c004a19>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type authorSeoAuthor$data = {
  readonly bio: string | null;
  readonly entityId: string;
  readonly name: string;
  readonly urlAlias: string;
  readonly " $fragmentType": "authorSeoAuthor";
};
export type authorSeoAuthor$key = {
  readonly " $data"?: authorSeoAuthor$data;
  readonly " $fragmentSpreads": FragmentRefs<"authorSeoAuthor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "authorSeoAuthor",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    }
  ],
  "type": "Author",
  "abstractKey": null
};

(node as any).hash = "860f2e06f23225f44be640c28f1ed041";

export default node;
